// extracted by css-extract-rspack-plugin
export default {"root":"root-oAbQcM","group":"group-kb9Apw","trigger":"trigger-ZNBMDY","triggerActive":"triggerActive-GAkYAf","triggerLabel":"triggerLabel-eZXMCI"};